import React from 'react';
import NoSolutionSelected from '../List/components/NoSolutionSelected';
import Training from './Training';
import Policy from './Policy';
import Accreditation from './Accreditation';
import PerformanceReporting from './PerformanceReporting';
import RiskPoolSolutions from './RiskPoolSolutions';
import { RISK_POOL_AVAILABLE_SOLUTIONS } from './RiskPoolSolutions';
import { useManageSolutionsContext } from '../context';

const Detail: React.FC = () => {
  const { selectedSolution, orgRiskPoolEnabled } = useManageSolutionsContext();

  // No solution selected state
  if (!selectedSolution) {
    return <NoSolutionSelected />;
  }

  const solutionKey = selectedSolution.key;

  // If Risk Pool is enabled, check if the selected solution is in RISK_POOL_AVAILABLE_SOLUTIONS
  // If it is, use RiskPoolSolutions component. Otherwise, fall back to regular solution components
  // (this allows active solutions that aren't in RISK_POOL_AVAILABLE_SOLUTIONS to still be displayed)
  if (orgRiskPoolEnabled) {
    if (RISK_POOL_AVAILABLE_SOLUTIONS.includes(solutionKey)) {
      return <RiskPoolSolutions />;
    }
    // Fall through to regular solution components for active solutions not in RISK_POOL_AVAILABLE_SOLUTIONS
  }

  // Define solution components mapping
  const solutionComponents: Record<string, JSX.Element> = {
    awb: <Accreditation />,
    training: <Training />,
    policy: <Policy />,
    'performance-reporting': <PerformanceReporting />,
  };

  return solutionComponents[solutionKey] ?? null;
};

export default Detail;
